/**
 * Onboarding Day 1 email CTAs: button copy and entry URLs for templates.
 * Append UTM params in sends (e.g. utm_campaign=onboarding_day1&utm_source=email&utm_content=<slug>).
 * Paths are relative to the app origin.
 */
export const ONBOARDING_DAY1_EMAIL_CTAS = [
  {
    title: 'Summarize',
    emailPath: '/email/summarize',
    destinationPath: '/chat',
  },
  {
    title: 'App Marketplace',
    emailPath: '/email/app-marketplace',
    destinationPath: '/profile/integrations',
  },
  {
    title: 'Password Reset',
    emailPath: '/email/password-reset',
    destinationPath: '/profile/password',
  },
  {
    title: 'Account Security',
    emailPath: '/email/account-security',
    destinationPath: '/profile/authentication',
  },
  {
    title: 'Analytics',
    emailPath: '/email/analytics',
    destinationPath: '/profile/plan-usage',
  },
] as const;

export type OnboardingDay1EmailCta = (typeof ONBOARDING_DAY1_EMAIL_CTAS)[number];
